import FlexPane from './_flex-pane.js'
import Hideable from './_hideable.js'
import TextInput from './_text-input.js'
import CustomTextInput from './_custom-text-input.js'
import Checkbox from './_checkbox.js'

export default {
  name: 'StakeInput',
  values: {
    decimalAmount: 2,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
        },
      },
    },
    useCustomTextInput: false,
    _mobile_useCustomTextInput: true,
    inputVisibility: {
      configSet: Hideable,
      configValues: {},
    },
    textInput: {
      configSet: TextInput,
      configValues: {
        inputMode: 'decimal',
        style: {
          base: {
            maxWidth: '72px',
            minHeight: '40px',
            padding: '0px 4px',
            borderRadius: '4px',
            textAlign: 'right',
          },
          disabled: {
            borderWidth: 0,
            borderRadius: 0,
          },
        },
      },
    },
    customTextInput: {
      configSet: CustomTextInput,
      configValues: {
        style: {
          base: {
            minWidth: '72px',
            maxWidth: '72px',
            minHeight: '40px',
            padding: '0px 4px',
            borderRadius: '4px',
            textAlign: 'right',
          },
          disabled: {
            borderWidth: 0,
            borderRadius: 0,
          },
        },
      },
    },
    checkbox: {
      configSet: Checkbox,
      configValues: {
        container: {
          style: {
            base: {
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0 2px 0 0',
            },
          },
        },
      },
    },
    $mixin: [
      {
        configSet: Hideable,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
